import { FormProps } from '@r-and-a-shared-ui/common-forms-ui';

export type MaxApplicationsPerRole = {
  key?: string;
  item: {
    key?: string;
    value?: string;
  };
};
export enum PPFormTypes {
  Classic = 'none',
  WithPreviewAndModal = 'with_preview_and_modal',
}

export type PPFormType = 'classic' | 'with_preview_and_modal';
export type PlayerPortalsFormProps = FormProps & {
  formType: PPFormType;
  onDefaultValuesFetched?: (values: any) => void;
  onFormClosed?: () => void;
  defaultValuesEntity?: string[];
  customClassname?: string;
  customId?: string;
  isAccreditationForm?: boolean;
  isCreateCaddieForm?: boolean;
  selectedChampionshipPlayerId?: string;
  selectedChampionshipCaddieId?: string;
  accreditationFormOpenBtnLabel?: string;
  accreditationFormKontentItemCodename?: string;
  hasFetchedAccreditations?: boolean;
  maxNumberOfApplicationsPerRole?: MaxApplicationsPerRole[];
  currentApplicationsPerRoleCount?: Record<string, number>;
  maxNumberOfNominatedForDinner?: number;
  currentNominatedForDinnerCount?: number;
  kontentItemId?: string;
};
